import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _ from 'lodash';
import { Carte } from 'src/app/models/carte';
import { DocumentService } from 'src/app/services/document.service';
import { CoreData } from 'src/app/tools/core-data';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { ConfirmBoxModel } from 'src/app/tools/ui/confirm-box/confirm-box.model';
import { EDocumentType } from 'src/app/tools/ui/mutilple-file-upload-box/document-type';
import { MultipleFileUploadBoxDialog } from 'src/app/tools/ui/mutilple-file-upload-box/multiple-file-upload-box';

@Component({
  selector: 'app-sampling-point-map',
  templateUrl: './sampling-point-map.component.html',
  styleUrl: './sampling-point-map.component.scss'
})
export class SamplingPointMapComponent {
    CarteList: Carte[] = [];
    SearchText: string = ''

    constructor(
        public coreData: CoreData,
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
        private documentService: DocumentService) { }

    ngOnInit(): void {

    }

    ngAfterContentInit(): void {
        this.getAllLotList();
    }

    openMultipleUploadDialog() {

        const dialogRef = this.dialog.open(MultipleFileUploadBoxDialog, {
            data: { code: undefined, type: EDocumentType.PhotoSamplingPoint, withInputText: true, label: 'Sampling Point Code' },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                NotificationManager.handleSuccess('Lot correctement ajouté !', this.snackBar);
                this.getAllLotList();
            }
        });
    }

    //#region SERVICE
    getDocumentFile(documentCode: string) {
        this.documentService.getDocument(documentCode).subscribe(x => {
            this.promptFile(x);
        });
    }

    promptFile(x: any) {
        var url = window.URL.createObjectURL(x.body);
        var a = document.createElement('a');

        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(x.headers.get('Content-Disposition'));
        if (matches != null && matches[1]) {
            a.download = matches[1].replace(/['"]/g, '');
        }

        a.href = url;
        // a.download = x.fileName;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();  //afterwards we remove the element again 
    }

    deleteLot(carte: Carte) {
        const m: ConfirmBoxModel = new ConfirmBoxModel();
        m.QuestionTitle = 'Etes-vous sûr de vouloir supprimer la carte ?';
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: m,
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: ConfirmBoxModel) => {
            if (!result)
                return;

            this.documentService.deleteLot(carte.SamlingPointCode).subscribe(x => {
                if (x) {
                    NotificationManager.handleSuccess('Carte correctement supprimé !', this.snackBar);
                    _.remove(this.CarteList, x => x.DocumentCode === carte.DocumentCode)
                }
            })
        })
    }

    getAllLotList() {
        this.documentService.getLast30Lot().subscribe(x => {
            this.CarteList = x;
        })
    }

    getLotListByFilter() {
        this.documentService.getLotByFilter(this.SearchText).subscribe(x => {
            this.CarteList = x;
        })
    }

    //#endregion
}
